import Vue from 'vue';

Vue.mixin({
  computed: {
    current_layout: function () {
      return this.$root.$children[1];
    }
  },
});